import React, { type FC, useEffect } from 'react'
import logo from '../../../assets/koka_logo.png'
import Button from '@mui/material/Button'
import { Card, CardActions, CardContent, CardHeader, Typography } from '@mui/material'
import CircularProgress from '@mui/material/CircularProgress'

import { Navigate } from 'react-router-dom'
import { FetchingUserInformationAction, LogoutSuccessAction } from '../../../redux/auth/auth-actions'
import { useTranslation } from 'react-i18next'
import { useAppDispatch, useAppSelector } from '../../../redux/hooks'
import { type RootState } from '../../../redux/store'
import { AddMessageAction } from '../../../redux/messages/messages-actions'
import { MessageTypes } from '../../../redux/messages/messages-types'

export const Landing: FC = () => {
  const dispatch = useAppDispatch()
  const isAssignedToCompany = useAppSelector((state: RootState): boolean => state.auth.isAssignedToCompany)
  const errorMessageKey = useAppSelector((state: RootState): string | null => state.auth.errorMessageKey)

  useEffect(() => {
    if (errorMessageKey !== null) {
      dispatch(AddMessageAction(errorMessageKey, MessageTypes.error))
    }
  }, [dispatch, errorMessageKey])

  if (isAssignedToCompany) {
    return (<Navigate to='/dashboard/meters'/>)
  } else {
    return (<NotAssignedToCompanyNotice/>)
  }
}

/* Child-components */

function NotAssignedToCompanyNotice(): React.ReactElement {
  const dispatch = useAppDispatch()
  const { t } = useTranslation()

  const username = useAppSelector((state: RootState): string => state.auth.username)
  const isFetchingUserInformation =
        useAppSelector((state: RootState): boolean => state.auth.isFetchingUserInformation)

  return (

        <div className="Aligner">
            <div className="Aligner-item--top"/>
            <div className="Aligner-item">{isFetchingUserInformation
              ? <div style={{ textAlign: 'center' }}><CircularProgress/></div>
              : <Card>
                    <CardHeader
                        title={t('landing.welcome')}
                        subtitle={username}
                    />
                    <CardContent style={{ textAlign: 'center' }}>
                        <img src={logo} style={{ width: '300px' }} alt="logo"/>
                        <p>{t('landing.info')}</p>
                    </CardContent>
                    <CardActions>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => dispatch(FetchingUserInformationAction())}>
                            <Typography>{t('landing.try_login')}</Typography>
                        </Button>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => dispatch(LogoutSuccessAction())}>
                            <Typography>{t('landing.logout')}</Typography>
                        </Button>
                    </CardActions>
                </Card>}
            </div>
            <div className="Aligner-item--bottom"/>
        </div>
  )
}
